<div class="main">
  <mat-toolbar class="header">
    <span>Akiru Landing Portal</span>
    <span class="flex-grow"></span>
    <!-- This is not a "button" and refuses to behave -->
    <div style="margin-top: 7px">
      <aku-toggle-button/>
    </div>
    <button [routerLink]="['/', 'home']" matIconButton>
      <mat-icon>home</mat-icon>
    </button>
    <button [matMenuTriggerFor]="menu" matIconButton>
      <mat-icon>menu</mat-icon>
    </button>
  </mat-toolbar>
  <div class="drawer-holder">
    @if (!sidenav.opened) {
      <div>
        <button (click)="sidenav.toggle()" matIconButton>
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    }

    <mat-drawer-container class="container">
      <mat-drawer #sidenav class="drawer" mode="side">
        <mat-card>
          <div class="card-header">
            <h2>Navigation</h2>
            <button (click)="sidenav.toggle()" matIconButton>
              <mat-icon>chevron_left</mat-icon>
            </button>
          </div>
          <mat-card-content>
            <button [routerLink]="['/', 'login-settings']" matButton="elevated">
              <mat-icon>settings</mat-icon>
              Login Settings
            </button>
          </mat-card-content>
        </mat-card>
      </mat-drawer>

      <mat-drawer-content>
        <div [style.margin-left.px]="sidenav.opened ? 20 : 0">
          <router-outlet/>
        </div>
      </mat-drawer-content>
    </mat-drawer-container>
  </div>
  <div class="flex-grow"></div>
  <div class="footer">
    <a href="https://akiru.se" matButton="text">© 2026 - Akiru Studios AB</a>
    {{ version }}
    <button matButton="text" (click)="license()">Open Source Licenses</button>
  </div>
</div>

<mat-menu #menu="matMenu">
  <button [routerLink]="['/']" mat-menu-item>Start</button>
  <button [routerLink]="['/', 'deploy']" mat-menu-item>Deploy</button>
  <button [routerLink]="['/', 'logged-in']" mat-menu-item>Credentials</button>
</mat-menu>